import { BaseFinalCommand } from "./BaseFinalCommand";

export class HelpCommand extends BaseFinalCommand
{
    constructor(argv: string[])
    {
        super(argv, [], []);
    }
    override async exec()
    {
        this.app.main.help();
    }
}